import React, { useContext, useEffect, useState } from "react";
import CodingGroupsDataGrid from "components/shared/CodingGroupComponents/CodingGroupsDataGrid";
import FiltersComponent from "components/shared/CodingGroupComponents/FiltersComponent";
import TopPanelComponent from "components/shared/CodingGroupComponents/TopPanelComponent";
import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import api from "api";
import { useNavigate } from "react-router-dom";
import { UserContext } from "context";
import CustomGridToolbar from "components/GridToolbar";

const ProcedureGroups = () => {
  const [rowData, setRowData] = useState([]);
  const user = useContext(UserContext);
  const canEditOrCreate =
    user?.groups?.includes("POET-Avalon-Admin") ||
    (user?.groups?.includes("POET-Avalon-POE") &&
      (user?.POETSkill?.includes("Coding") ||
        user?.POETSkill?.includes("Manager")));

  const navigate = useNavigate();

  const fetchProcedureCodeGroups = async () => {
    const response = await api.procedureCode.getCodeGroupProcedureCodeList();
    return response.data.map((item) => ({
      ...item,
      codeGroupVersion:
        item.codeGroupVersion !== undefined
          ? Number(item.codeGroupVersion).toFixed(1)
          : item.codeGroupVersion,
    }));
  };

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await fetchProcedureCodeGroups();
        if (!cancelled) setRowData(data); // setState in async callback ✅
      } catch (error) {
        // safe to log or surface via a dialog
        console.error("Error fetching Procedure code groups:", error);
      }
    })();

    return () => {
      cancelled = true; // avoid setting state after unmount
    };
  }, []);

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer
        sx={{
          "& .MuiDataGrid-toolbar, & .MuiDataGrid-toolbarContainer": {
            borderBottom: "none",
          },
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={1}
          width="100%"
        >
          {canEditOrCreate ? (
            <Link
              component={RouterLink}
              to="/coding-group-editor"
              state={{ page: "Procedure Groups" }}
              underline="always"
              sx={{ fontWeight: "bold" }}
            >
              Create Procedure Group
            </Link>
          ) : (
            <Box
              sx={{
                fontWeight: "bold",
                color: "text.disabled",
                cursor: "not-allowed",
                textDecoration: "underline",
                opacity: 0.6,
              }}
            >
              Create Procedure Group
            </Box>
          )}
          <Box
            sx={{
              width: "33%",
              flex: "0 0 33%",
              maxWidth: "33%",
            }}
          >
            <CustomGridToolbar
              quickFilterParser={(searchInput) =>
                searchInput.split(",").map((value) => value.trim())
              }
            />
          </Box>
        </Box>
      </GridToolbarContainer>
    );
  };

  const handleRowClick = (params) => {
    // Handle row click event
    navigate(`/coding-group-editor/${params.row.codeGroupKey}`, {
      state: { page: "Procedure Groups" },
    });
  };
  return (
    <div>
      <TopPanelComponent page="Procedure Groups" />
      <FiltersComponent />
      <CodingGroupsDataGrid
        rowData={rowData}
        CustomToolbar={CustomToolbar}
        getRowId={(row) => row.codeGroupKey}
        onRowClick={handleRowClick}
      />
    </div>
  );
};

export default ProcedureGroups;
